import { GET_DRAWER_START } from "../../types";

export const drawer = (payload) => ({
  type: GET_DRAWER_START,
  payload,
});
